import createClient from 'openapi-fetch';

import { authMiddleware, errorMiddleware } from './middleware/truefilesApiMiddleware';
// TODO: Alias paths
import { paths } from '../../api-clients/truefiles-server';

export type HttpMethod =
  | 'get'
  | 'put'
  | 'post'
  | 'delete'
  | 'options'
  | 'head'
  | 'patch'
  | 'trace';

export type PathsWithMethod<
  Paths extends {},
  PathnameMethod extends HttpMethod,
> = {
  [Pathname in keyof Paths]: Paths[Pathname] extends {
    [K in PathnameMethod]: any;
  }
    ? Pathname
    : never;
}[keyof Paths];

export const truefileServerApi = createClient<paths>({
  baseUrl: '/',
});

truefileServerApi.use(
  authMiddleware,
  errorMiddleware,
);
